<template>
	<div v-if="!mobile" class="picker-group">
		<div class="reason-column" :class="{ 'other-active': reason === 'other' }">
			<VueScrollPicker :options="reasons" v-model="reason" @start="startPickerMoveHaptics('reason', reason)" @move="triggerPickerMoveHaptic('reason', $event)" @end="resetPickerMoveHaptics('reason')" @cancel="resetPickerMoveHaptics('reason')" @click="triggerPickerMoveHaptic('reason', $event)" />
			<VTextField v-if="reason === 'other'" ref="otherInput" v-model="otherReason" class="other-reason-input" variant="plain" :hide-details="true" :clearable="false" density="comfortable" :autofocus="true" placeholder="other" />
		</div>
    <div class="since-column">
      <span class="since">since</span>
    </div>
    <div class="month-column">
      <VueScrollPicker :options="months" v-model="selectedMonth" class="month-column" @start="startPickerMoveHaptics('month', selectedMonth)" @move="triggerPickerMoveHaptic('month', $event)" @end="resetPickerMoveHaptics('month')" @cancel="resetPickerMoveHaptics('month')" @wheel="triggerPickerMoveHaptic('month', $event)" @click="triggerPickerMoveHaptic('month', $event)" />
    </div>
    <div class="day-column">
      <VueScrollPicker :options="days" v-model="selectedDay" class="day-column" @start="startPickerMoveHaptics('day', selectedDay)" @move="triggerPickerMoveHaptic('day', $event)" @end="resetPickerMoveHaptics('day')" @cancel="resetPickerMoveHaptics('day')" @wheel="triggerPickerMoveHaptic('day', $event)" @click="triggerPickerMoveHaptic('day', $event)" />
    </div>
    <div class="year-column">
      <VueScrollPicker :options="years" v-model="selectedYear" class="year-column" @start="startPickerMoveHaptics('year', selectedYear)" @move="triggerPickerMoveHaptic('year', $event)" @end="resetPickerMoveHaptics('year')" @cancel="resetPickerMoveHaptics('year')" @wheel="triggerPickerMoveHaptic('year', $event)" @click="triggerPickerMoveHaptic('year', $event)" />
    </div>
    <div class="btn-container">
      <button class="calculate-days" @click="calculateDays"><VIcon size="20" style="line-height:30px;">mdi-white-balance-sunny</VIcon></button>
      <button v-if="showCancelRemove" class="cancel-daycount" type="button" @click="cancelDayCount"><VIcon class="cancel-daycount-icon" size="18">mdi-close</VIcon></button>
    </div>
  </div>
  <div v-else class="picker-group mobile">
    <button v-if="showCancelRemove" class="cancel-daycount mobile-cancel-daycount" type="button" @click="cancelDayCount"><VIcon class="cancel-daycount-icon" size="18">mdi-close</VIcon></button>
    <v-carousel
      v-model="currentIndex"
      style="width:100vw;height:70vh;"
      hide-delimiters
      :continuous="false"
    >
      <template v-slot:prev="{ props }">
        <v-btn
          color="primary"
          variant="outlined"
          icon="mdi-chevron-left"
          @click="props.onClick"
        />
      </template>
      <template v-slot:next="{ props }">
        <v-btn
          v-if="currentIndex === 0"
          color="primary"
          rounded
          variant="outlined"
          append-icon="mdi-chevron-right"
          @click="props.onClick"
        ><span class="since-mobile">since</span></v-btn>

        <v-btn
          v-else-if="currentIndex === 1 || currentIndex === 2"
          color="primary"
          variant="outlined"
          icon="mdi-chevron-right"
          @click="props.onClick"
        />
        <VBtn v-else color="primary" @click="calculateDays" icon="mdi-white-balance-sunny" variant="outlined" />

      </template>
      <v-carousel-item>
        <div :class="{ 'other-active': reason === 'other' }">
          <VueScrollPicker :options="reasons" v-model="reason" class="mobile-picker mobile-reasons-picker" @start="startPickerMoveHaptics('reason', reason)" @move="triggerPickerMoveHaptic('reason', $event)" @end="resetPickerMoveHaptics('reason')" @cancel="resetPickerMoveHaptics('reason')" @click="triggerPickerMoveHaptic('reason', $event)" />
          <VTextField v-if="reason === 'other'" ref="otherInput" v-model="otherReason" class="other-reason-input" variant="plain" :hide-details="true" :clearable="false" density="comfortable" :autofocus="true" placeholder="other" />
        </div>
      </v-carousel-item>
      <v-carousel-item>
        <div>
          <VueScrollPicker :options="months" v-model="selectedMonth" class="month-column mobile-picker" @start="startPickerMoveHaptics('month', selectedMonth)" @move="triggerPickerMoveHaptic('month', $event)" @end="resetPickerMoveHaptics('month')" @cancel="resetPickerMoveHaptics('month')" @wheel="triggerPickerMoveHaptic('month', $event)" @click="triggerPickerMoveHaptic('month', $event)" />
        </div>
      </v-carousel-item>
      <v-carousel-item>
        <div>
          <VueScrollPicker :options="days" v-model="selectedDay" class="day-column mobile-picker" @start="startPickerMoveHaptics('day', selectedDay)" @move="triggerPickerMoveHaptic('day', $event)" @end="resetPickerMoveHaptics('day')" @cancel="resetPickerMoveHaptics('day')" @wheel="triggerPickerMoveHaptic('day', $event)" @click="triggerPickerMoveHaptic('day', $event)" />
        </div>
      </v-carousel-item>
      <v-carousel-item>
        <div>
          <VueScrollPicker :options="years" v-model="selectedYear" class="year-column mobile-picker" @start="startPickerMoveHaptics('year', selectedYear)" @move="triggerPickerMoveHaptic('year', $event)" @end="resetPickerMoveHaptics('year')" @cancel="resetPickerMoveHaptics('year')" @wheel="triggerPickerMoveHaptic('year', $event)" @click="triggerPickerMoveHaptic('year', $event)" />
        </div>
      </v-carousel-item>
      <v-carousel-item></v-carousel-item>
    </v-carousel>
  </div>
</template>
<script>
  import { Capacitor } from '@capacitor/core';
  import { Haptics, ImpactStyle } from '@capacitor/haptics';
	import { VueScrollPicker } from 'vue-scroll-picker';
  import { track } from '../utils/analytics';
  import { computeDaysSince, resolveReason } from '../shared/dayCount';
  import { parseQueryParams } from '../utils/params';
  import { readSelections } from '../storage/browserStorage';

export default {
  name: 'PickerGroup',
  components: {
    VueScrollPicker, // export VueScrollPicker is component
  },
  props: {
    initialDayCount: {
      type: Object,
      default: null,
    },
    showCancelRemove: {
      type: Boolean,
      default: false,
    },
    useStoredSelections: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['dayCount', 'cancelDayCount'],
  data() {
    return {
      selectedYear: 2010,
      selectedMonth: 6,
      selectedDay: 15,
      reason: "alive",
      otherReason: "",
      currentIndex: 0,
      hapticsReady: false,
      pickerMoveValues: {},
    }
  },
  mounted() {
    this.prepareSelections();
    this.$nextTick(() => {
      this.hapticsReady = true;
    });
  },
  activated() {
    this.prepareSelections();
  },
  watch: {
    selectedYear() {
      this.saveSelections();
    },
    selectedMonth() {
      this.saveSelections();
    },
    selectedDay() {
      this.saveSelections();
    },
    reason(newVal) {
      this.saveSelections();
      track('reason_selected', { reason: newVal });
      if (newVal === 'other') {
        this.focusOtherInput();
      }
    },
    otherReason() { this.saveSelections(); },
    initialDayCount: {
      handler() {
        this.prepareSelections();
      },
      deep: true,
    },
    useStoredSelections() {
      this.prepareSelections();
    },
  },
  computed: {
    mobile() {
      return this.$vuetify.display.mobile;
    },
    years() {
      const currYear = new Date().getFullYear()
      const lastYear = 1900
      return Array.from({ length: currYear - lastYear + 1 }, (_, index) => lastYear + index).reverse()
    },
    months() {
      return Array({ value: '01', name: 'January' },
        { value: '02', name: 'February' },
        { value: '03', name: 'March' },
        { value: '04', name: 'April' },
        { value: '05', name: 'May' },
        { value: '06', name: 'June' },
        { value: '07', name: 'July' },
        { value: '08', name: 'August' },
        { value: '09', name: 'September' },
        { value: '10', name: 'October' },
        { value: '11', name: 'November' },
        { value: '12', name: 'December' })
    },
    days() {
      const lastDay = new Date(this.selectedYear, this.selectedMonth, 0).getDate()
      return Array.from({ length: lastDay }, (_, index) => index + 1)
    },
    reasons() {
      return Array('married','alive','a parent','a grandparent','sober','born again','other')
    },
  },
  methods: {
    prepareSelections() {
      if (this.initialDayCount) {
        this.applyDayCountToSelections(this.initialDayCount);
      } else if (this.useStoredSelections) {
        const appliedFromUrl = this.applySelectionsFromUrl();
        if (!appliedFromUrl) {
          this.restoreSelections();
        }
      } else {
        this.resetSelectionsToDefault();
      }

      if (this.reason === 'other') {
        this.focusOtherInput();
      }
    },
    resetSelectionsToDefault() {
      this.selectedYear = 2010;
      this.selectedMonth = 6;
      this.selectedDay = 15;
      this.reason = 'alive';
      this.otherReason = '';
      this.currentIndex = 0;
    },
    applyDayCountToSelections(dayCount) {
      if (!dayCount || !dayCount.selectedDate) return;

      this.selectedYear = dayCount.selectedDate.year;
      this.selectedMonth = dayCount.selectedDate.month;
      this.selectedDay = dayCount.selectedDate.day;
      this.reason = dayCount.reason || 'alive';
      this.otherReason = dayCount.otherReason || '';
      this.currentIndex = 0;
    },
    canUseNativeHaptics() {
      return this.hapticsReady && Capacitor.isNativePlatform();
    },
    startPickerMoveHaptics(pickerKey, currentValue) {
      this.pickerMoveValues[pickerKey] = currentValue;
    },
    resetPickerMoveHaptics(pickerKey) {
      delete this.pickerMoveValues[pickerKey];
    },
    triggerPickerMoveHaptic(pickerKey, value) {
      if (this.pickerMoveValues[pickerKey] === value) return;

      this.pickerMoveValues[pickerKey] = value;
      this.triggerPickerHaptic();
    },
    triggerPickerHaptic() {
      if (!this.canUseNativeHaptics()) return;

      Haptics.impact({ style: ImpactStyle.Light }).catch(() => {
        // Haptics can be unavailable in simulators or unsupported native contexts.
      });
    },
    focusOtherInput() {
      this.$nextTick(() => {
        const ref = this.$refs.otherInput;
        if (ref && typeof ref.focus === 'function') {
          ref.focus();
          return;
        }
        const el = ref && ref.$el ? ref.$el : null;
        const input = el && el.querySelector ? el.querySelector('input') : null;
        if (input) input.focus();
      });
    },
    saveSelections() {
      // Draft picker changes are persisted only when the user calculates.
    },
    applySelectionsFromUrl() {
      try {
        const parsed = parseQueryParams(window.location.search);
        if (!parsed || !parsed.anySet) return false;
        if (parsed.reason) this.reason = parsed.reason;
        if (parsed.otherReason) this.otherReason = parsed.otherReason;
        if (parsed.month != null) this.selectedMonth = parsed.month;
        if (parsed.day != null) this.selectedDay = parsed.day;
        if (parsed.year != null) this.selectedYear = parsed.year;
        return true;
      } catch (e) {
        return false;
      }
    },
    restoreSelections() {
      try {
        const data = readSelections();
        if (data && typeof data === 'object') {
          if (typeof data.reason === 'string') this.reason = (data.reason === 'other...' ? 'other' : data.reason);
          if (typeof data.otherReason === 'string') this.otherReason = data.otherReason;
          if (typeof data.selectedMonth === 'string' || typeof data.selectedMonth === 'number') this.selectedMonth = data.selectedMonth;
          if (typeof data.selectedDay === 'string' || typeof data.selectedDay === 'number') this.selectedDay = data.selectedDay;
          if (typeof data.selectedYear === 'string' || typeof data.selectedYear === 'number') this.selectedYear = data.selectedYear;
        }
      } catch (e) {
        // ignore corrupt payloads
      }
    },
    cancelDayCount() {
      this.$emit('cancelDayCount');
    },
    calculateDays() {
      this.triggerPickerHaptic();
      const days = computeDaysSince(this.selectedYear, this.selectedMonth, this.selectedDay);
      
      const computedReason = resolveReason(this.reason, this.otherReason);

      // Track finalized reason selection (includes otherReason if provided)
      track('reason_finalized', { reason: computedReason });

      this.$emit('dayCount', {
        days,
        why: computedReason,
        reason: this.reason,
        otherReason: this.otherReason,
        selectedDate: {
          year: this.selectedYear,
          month: this.selectedMonth,
          day: this.selectedDay,
        },
      });
      this.currentIndex = 0;
    }
  },
}
</script>
<style>



@media (min-width: 320px) and (max-width: 480px) {

}

.since {
  font-family:'Montserrat',sans-serif;
  color:#fff;
  font-size:2rem;
  font-weight:200;
}

.since-mobile {
  font-family:'Montserrat',sans-serif;
  text-transform: lowercase;
}

.reason-column {
  width:14.25rem;
  margin-right:3.75rem;
  position: relative;
}

.since-column {
  width:6.75rem;
  margin-right:3.75rem;
  display: inline-block;
  text-align: center;
  align-content: center;
}

.month-column {
  width:11.25rem;
  margin-right:3.75rem;
}

.day-column {
  width:3.25rem;
  margin-right:3.75rem;
}

.year-column {
  width:5.75rem;
  margin-right:3.75rem;
}

.vue-scroll-picker {
    position: relative;
    width: 100%;
    height: 15em;
    mask-image:linear-gradient(to bottom, rgba(242,239,136,0) 0%,rgba(242,239,136,0.65) 42%,rgba(242,239,136,1) 43%,rgba(242,239,136,1) 57%,rgba(242,239,136,0.65) 58%,rgba(242,239,136,0) 100%);
}
.mobile-picker {
  height: 35rem;
}
.vue-scroll-picker-rotator {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(50% - 1em);
}
.vue-scroll-picker-rotator-transition {
    transition: top ease 0.15s;
}
.vue-scroll-picker-item {
    text-align: center;
    font-size: 2rem;
    font-family:'Montserrat',sans-serif;
    font-weight:200;
    line-height: 1.2em;
    color: #F2EF88;
}
.vue-scroll-picker-item-selected {
    color: #F2EF88;
}
.vue-scroll-picker-item-empty,
.vue-scroll-picker-item-placeholder,
.vue-scroll-picker-item-disabled {
    color: #ccc;
}
.vue-scroll-picker-item-empty.vue-scroll-picker-item-selected,
.vue-scroll-picker-item-placeholder.vue-scroll-picker-item-selected,
.vue-scroll-picker-item-disabled.vue-scroll-picker-item-selected {
    color: #aaa;
}
.vue-scroll-picker-layer {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}
.vue-scroll-picker-layer-top,
.vue-scroll-picker-layer-selection,
.vue-scroll-picker-layer-bottom {
    position: absolute;
    left: 0;
    right: 0;
}
.vue-scroll-picker-layer-top {
    box-sizing: border-box;
    /* border-bottom: 1px solid #c8c7cc;
    background: linear-gradient(0deg, rgba(23,44,73,0.4) 0%, rgba(22,37,67,0.9) 75%, rgba(21,35,65,1) 100%); */
    top: 0;
    height: calc(50% - 1em);
    cursor: pointer;
}
.vue-scroll-picker-layer-selection {
    top: calc(50% - 1em);
    bottom: calc(50% - 1em);
}
.vue-scroll-picker-layer-bottom {
    /*border-top: 1px solid #c8c7cc; 
    background: linear-gradient(180deg, rgba(24,46,76,0.4) 0%, rgba(27,53,83,0.9) 75%, rgba(28,55,85,1) 100%); */
    bottom: 0;
    height: calc(50% - 1em);
    cursor: pointer;
}

.picker-group {
  display: flex;
  margin:0 auto;
  padding-top:60px;
}


.btn-container {
  height:15em;
  align-content: center;
  width: auto;
  min-width: 6rem;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 16px;
}

.btn-container .calculate-days {
  flex: 0 0 96px;
}

.calculate-days :hover {
  font-variation-settings:
  'FILL' 1
}

.calculate-days-mobile {
  height:46px !important;
  width:46px !important;
  border-radius:23px !important;
  border:1px solid #F2EF88 !important;
  line-height:44px !important;
  font-size:22px !important;
}

.cancel-daycount {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  flex: 0 0 36px;
  border: 1px solid #F2EF88;
  border-radius: 999px;
  color: #F2EF88;
  opacity: 0.5;
  background: rgba(242,239,136,0);
  cursor: pointer;
  transition: opacity 150ms ease;
}

.cancel-daycount:hover {
  opacity: 0.8;
}

.cancel-daycount .cancel-daycount-icon {
  color: #F2EF88 !important;
}

.mobile-cancel-daycount {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
}

/* When other is active, visually hide the selected picker item so the input appears in its place */
.reason-column.other-active .vue-scroll-picker-item-selected {
  color: transparent;
}

/* Overlay input styled like a picker item and centered on the selection line */
.other-reason-input {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  padding: 0 8px;
}
.other-reason-input .v-field {
  background: transparent !important;
  box-shadow: none !important;
}
.other-reason-input .v-field__overlay,
.other-reason-input .v-field__outline {
  display: none !important;
}
.other-reason-input .v-field__input {
  text-align: left;
  font-size: 2rem;
  font-family:'Montserrat',sans-serif;
  font-weight:200;
  line-height: 1.2em;
  color: #F2EF88;
  height: 1.2em;
  padding: 0;
  padding-left: 3rem;
}
.other-reason-input input::placeholder {
  color: #ccc;
}

.picker-group.mobile .vue-scroll-picker-item {
  line-height: 1.75em; /* was 1.2em; the component's layers assume 2em */
}

/* Mobile reasons list only: left-align item labels */
.picker-group.mobile .mobile-reasons-picker .vue-scroll-picker-item {
  text-align: left;
  padding-left: 3rem;
}

.picker-group.mobile {
  --mobile-picker-midline-offset: 0px;
}

/* Center mobile carousel pickers and overlay misc labels */
.picker-group.mobile .v-carousel-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.picker-group.mobile .v-carousel-item > div:first-child {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  transform: translateY(var(--mobile-picker-midline-offset, 0px));
}
.picker-group.mobile .v-carousel-item .text-center {
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
}

/* On mobile, hide selected text when overlay input is active */
.picker-group.mobile .other-active .vue-scroll-picker-item-selected {
  color: transparent;
}

/* Align picker em offsets with item line-height on mobile
   Item line-height = 1.2em of 2rem => 2.4rem; half = 1.2rem
   Make 1em inside the picker equal 1.2rem so center band aligns */
.picker-group.mobile .vue-scroll-picker {
  font-size: 1.25rem !important;
}
/* Center Vuetify carousel controls exactly on the midline (mobile only) */
.picker-group.mobile .v-window__controls {
  transform: translateY(var(--mobile-picker-midline-offset, 0px));
}
</style>